<app-container-transparent>

    <div fxLayout="row">
        <div fxFlex="60">
            <div fxLayout="column">
                <form [formGroup]="formPassword" (ngSubmit)="submitForm()">
                    <div fxLayout="column" style="margin-bottom: 50px;">
                        <img *ngIf="profileImage" src="data:image/jpeg;base64,{{ profileImage }}" height="60" width="60">
                        <label style="font-weight: bold;margin-bottom: 10px;color: #878179;">Foto Perfil:</label>
                        <input #inputFile class="form-control" type="file" [disabled]="uploadPicLoading" (change)="onChange($event)">
                        <mat-progress-bar mode="indeterminate" *ngIf="uploadPicLoading"></mat-progress-bar>
                    </div>

                    <div *ngIf="notEqualPassword" class="alert alert-danger">
                        <p>{{ notEqualPassword }}</p>
                    </div>

                    <div *ngIf="messageSuccess" class="alert alert-success">
                        <p>{{ messageSuccess }}</p>
                    </div>

                    <div *ngIf="messageError" class="alert alert-danger">
                        <p>{{ messageError }}</p>
                    </div>

                    <mat-form-field style="width: 100%" appearance="outline">
                        <mat-label>Senha atual</mat-label>
                        <input autocomplete="off" formControlName="currentPassword"
                               type="password"
                               matInput placeholder="Senha atual" required="true">
                    </mat-form-field>
                    <mat-form-field style="width: 100%" appearance="outline">
                        <mat-label>Nova Senha</mat-label>
                        <input autocomplete="off" formControlName="newPassword"
                               type="password"
                               matInput placeholder="Nova Senha" required="true">
                        <mat-hint>Tamanho mínimo 8 caracteres</mat-hint>
                    </mat-form-field>
                    <mat-form-field style="width: 100%" appearance="outline">
                        <mat-label>Confirmar nova senha</mat-label>
                        <input autocomplete="off" formControlName="confirmPassword"
                               type="password"
                               matInput placeholder="Confirmar nova senha" type="password" required="true">
                    </mat-form-field>

                    <mat-progress-bar *ngIf="submit"
                                      mode="indeterminate" color="primary"></mat-progress-bar>

                    <div>
                        <div fxFlex="80"></div>
                        <div fxFlex="5">
                            <button class="action-steps-btn" [disabled]="submit" mat-raised-button color="primary">
                                Alterar senha
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div fxFlex="40"></div>
    </div>

</app-container-transparent>
